module.exports = __webpack_public_path__ + "public/img/mdiBookSearchOutline.8c1a8e80.svg";